export const POST_CARD = 'POST_CARD';
export const LIST_CARD = 'LIST_CARD';
